import { render } from "./vstatementagent.vue?vue&type=template&id=761f3e9d&scoped=true"
import script from "./vstatementagent.vue?vue&type=script&lang=js"
export * from "./vstatementagent.vue?vue&type=script&lang=js"

import "./vstatementagent.vue?vue&type=style&index=0&id=761f3e9d&scoped=true&lang=css"

import exportComponent from "/var/jenkins_home/workspace/生产环境租户后台rent.syinba.com/jsvueweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-761f3e9d"]])

export default __exports__